<template>
  <div>
    <vue-snotify></vue-snotify>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"></loading>
    <b-row class="pb-3">
      <b-col lg="4">
        <h3>Documents</h3>
      </b-col>
      <b-col lg="4">
        <div class="">
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">Type</label>
            <v-select ref="docTypesDropdown" class="vue-select w-75" placeholder="All" :options="docTypeOptions" v-model="claim_type_id"
              :reduce="(option) => option.id"></v-select>
          </b-form>
        </div>
      </b-col>
      <b-col lg="4">
        <div class="">
          <b-input-group>
            <b-form-input class="search-outline" placeholder="Search Document"
              v-model="globalDocFilterStr"></b-form-input>
            <b-input-group-append>
              <b-button @click="clearGlobalDocSearchString" variant="outline-secondary"><i
                  class="fa-solid fa-times"></i></b-button>
              <b-button @click="startGlobalDocSearchString" variant="outline-secondary"><i
                  class="fa-solid fa-magnifying-glass"></i></b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row align-v="center" slot="header">
            <b-col cols="12">
              <h3 class="mb-0">Client Claim Evidence</h3>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <vuetable ref="vuetable" :api-mode="false" :fields="fields" :per-page="perPage"
                :data-manager="dataManager" pagination-path="pagination" @vuetable:pagination-data="onPaginationData">
                <template slot="source" scope="props">
                  <span>{{ client_name }}</span>
                </template>
                <template slot="fileName" scope="props">
                  <span v-html="getFileExtImg(props.rowData.fileExtention)" class="pr-2"></span>
                  <span v-html="truncateText(props.rowData.fileName)"></span>
                  <a v-if="props.rowData.fileName.length > 60" class="a-style" @click="
                    setActiveFileStr(props.rowData.fileName)
                    " v-b-modal.modal-file-str-upload-doc>
                    View More</a>
                </template>

                <template slot="documentTag" scope="props">
                  <b-button v-b-modal.modal-tag @click="tagDocumentModel(props.rowData)" variant="outline-secondary"
                    class="btn btn-sm"><i class="fa-solid fa-tag"></i></b-button>
                </template>
              </vuetable>
            </b-col>
            <b-col cols="12">
              <div style="padding-top: 10px">
                <vuetable-pagination-info v-show="claimDocumetList && claimDocumetList.length > 0"
                  ref="paginationInfo"></vuetable-pagination-info>
                <vuetable-pagination class="float-right" ref="pagination"
                  @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="4">
              <v-select class="vue-select" ref="uploadDocumentType" placeholder="Choose a Document Type"
                :options="documentTypes" label="type" v-model="documentType" :reduce="(option) => option.id"></v-select>
            </b-col>
            <b-col>
                <input type="file" ref="fileUploader" @change="onFileUploaded" :disabled="documentType === null" />
               
            </b-col>

          </b-row>


        </b-card>
      </b-col>
    </b-row>
    <b-card class="mt-2">
      <b-row align-v="center" slot="header">
        <b-col cols="12">
          <h3 class="mb-0">Document Explorer</h3>
        </b-col>
      </b-row>
      <DocumentExplorer :claim_id="claim_id" :client_id="client_id" :is_review="false"></DocumentExplorer>
    </b-card>

    <!-- Start Tag Modal -->
    <b-modal id="modal-tag" hide-footer>
      <template #modal-title>
        <h3>Tag Documents</h3>
      </template>
      <div>
        <table class="table table-bordered">
          <thead>
            <td>Select</td>
            <td>Type</td>
            <td>File Name</td>
          </thead>
          <tr v-for="(doc, index) in pendingUploadDocuments" :key="index">
            <td>
              <b-form-radio :value="doc.id" v-model="tagging_document"></b-form-radio>
            </td>
            <td>{{ doc.documentType.type }}</td>
            <td>{{ doc.fileName }}</td>
          </tr>
          <tr v-if="pendingUploadDocuments.length == 0">
            <td colspan="3">
              <div class="alert alert-warning">No pending documents to tag</div>
            </td>
          </tr>
        </table>
      </div>

      <div class="float-right mt-5">
        <b-button :disabled="!tagging_document" variant="primary" @click="tagClaimDocuments()">Update</b-button>
        <b-button variant="" @click="$bvModal.hide('modal-tag')">Cancel</b-button>
      </div>
    </b-modal>
    <!-- End Tag Modal -->

    <!-- Start File Str Modal -->
    <b-modal id="modal-file-str-upload-doc" hide-footer>
      <template #modal-title>
        <h3>Detail View</h3>
      </template>
      <div class="d-block">
        <b-row>
          <b-col cols="12">
            <p v-html="activeFileStr"></p>
          </b-col>
        </b-row>
      </div>

      <div class="float-right mt-5">
        <b-button variant="" @click="$bvModal.hide('modal-file-str-upload-doc')">Cancel</b-button>
      </div>
    </b-modal>
    <!-- End File Str Modal -->

    <!-- Start Report Link Modal -->
    <b-modal size="sm" id="modal-explore-file-document" hide-footer>
      <template #modal-title>
        <h3>Explore File</h3>
      </template>
      <div class="text-center">
        <span class="custom-non-br-undeline">
          <b-button variant="primary" target="_blank" :href="exploreFileLink">Click here to explore file</b-button>
        </span>
      </div>
      <div class="float-right mt-5"></div>
    </b-modal>
    <!-- End Report Link Modal -->

  </div>
</template>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "../Vuetable/VuetablePaginationBootstrap4";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo.vue";

import { GridComponent, ColumnsDirective, ColumnDirective, Filter, GridPlugin, Page, Sort, Toolbar, Edit, CommandColumn } from '@syncfusion/ej2-vue-grids';
import { DialogComponent } from '@syncfusion/ej2-vue-popups';
import { ButtonComponent } from '@syncfusion/ej2-vue-buttons';
import { TextBoxComponent } from "@syncfusion/ej2-vue-inputs";
import { UploaderComponent } from '@syncfusion/ej2-vue-inputs';

import DocumentDef from "./DocumentDef.js";
import "vue-select/dist/vue-select.css";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import moment from "moment";
import mixins from "./../../mixins/common.js";
import DocumentExplorer from "@/components/DocumentExplorer/DocumentExplorer.vue";

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    DocumentExplorer,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
    'ejs-button': ButtonComponent,
    'ejs-dialog': DialogComponent,
    'ejs-textbox': TextBoxComponent,
    'ejs-uploader': UploaderComponent


  },
  mixins: [mixins],
  props: ["client_id", "claim_id"],
  data() {
    return {
      fields: DocumentDef,
      selected: null,
      documents: [],
      perPage: 10,
      docTypeOptions: [],
      claim_type_id: "",
      globalDocFilterStr: "",
      claimDocumetList: [],
      pendingUploadDocuments: [],
      tagging_document: "",
      source_doc_id: "",
      activeFileStr: "",
      exploreFileLink: "",
      isLoading: false,
      fullPage: true,
      documentTypes: [],
      documentType: null,
      selectedFileForUpload: null,
      target: "#modalTarget",
      width: '335px',
      header: 'User Password',
      content: '',
      isModal: true,
      animationSettings: { effect: 'None' },
      toolbar: ['Edit', 'Delete', 'Update', 'Cancel'],
      editSettings: { allowEditing: true, allowDeleting: true },
      pageSettings: { pageSize: 2 },

      filterOptions: { type: 'Menu' },
      filterParams: { params: { showSpinButton: false } },

      contentTemplate: function () {
        return { template: contentTemplateVue }
      },

    };
  },
  mounted() {
    //clear snotofy
    this.clearSnotifyMessages();
    this.loadDocumentTypes();
    console.log("Document component mounted");

    this.$root.$on('renameDocument', () => {
      this.refreshClaimDocuments();
    });

    this.$root.$on('deleteDocument', () => {
      this.refreshClaimDocuments();
    });

    this.$root.$on('unDeleteDocument', () => {
      this.refreshClaimDocuments();
    });
  },
  watch: {
    claimDocumetList(newVal, oldVal) {
      this.$refs.vuetable.refresh();
    },
    claim_id: function (newVal, oldVal) {
      this.refreshClaimDocuments();
    },
    claim_type_id: function (newVal, oldVal) {
      this.$nextTick(() => {
        const inputElement = this.$refs.docTypesDropdown.$el.querySelector('input');
        if (inputElement) {
          inputElement.blur();
        }
      });



      this.$refs.vuetable.refresh();
    },
  },
  computed: {
    client_name: {
      get() {
        return this.$store.state.client_name;
      },
      set(val) {
        this.$store.state.client_name = val;
      },
    },
    documetList: {
      get() {
        return this.$store.state.documetList;
      },
      set(val) {
        this.$store.state.documetList = val;
      },
    },
    activeClaim: {
      get() {
        return this.$store.state.activeClaim;
      },
      set(val) {
        this.$store.state.activeClaim = val;
      },
    },
  },
  methods: {
    ...mapActions("admin", [
      "getAllClaimDocumentsWithArchive",
      "getAllPendingDocTypes",
      "tagClaimDocumentTypes",
      "getAllClaimDocuments",
      "getExploreFileLink",
      "loadCheckList",
      "documentRead"
    ]),
    loadDocumentTypes() {
      this.documentTypes = [];
      let params = {};
      this.loadCheckList(params).then((data) => {
        if (data.data.errors) {
        } else {
          this.documentTypes = data.data;
        }
      });
      console.log("document types loaded");
      console.log(this.documentTypes);
    },

    viewExploreFileLink() {
      this.exploreFileLink = "";
      this.isLoading = true;
      let claimdata = {
        claim_id: this.claim_id,
      };
      this.getExploreFileLink(claimdata).then((data) => {
        if (data.data.errors) {
          this.$snotify
            .error("Document data issue -Document Not Found ", "Error!", {
              position: "centerTop",
            })
            .on("destroyed", () => { });
        } else {
          if (
            data.data &&
            data.data.message &&
            this.validSharePointURL(data.data.message)
          ) {
            //window.open('file://localhost/DocumentStore/test.txt');

            this.exploreFileLink = data.data.message;
            this.$bvModal.show("modal-explore-file-document");
          } else {
            this.$snotify
              .error("Document validation issue - Document Not Found", "Error!", {
                position: "centerTop",
              })
              .on("destroyed", () => { });
          }
        }
        this.isLoading = false;
      });
    },
    setActiveFileStr(activeFileStr) {
      this.activeFileStr = activeFileStr;
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager(sortOrder, pagination) {
      let local = this.claimDocumetList;

      // account for search filter
      if (this.claim_type_id) {
        let claim_type_str = this.claim_type_id;
        let dataFil = _.filter(local, function (item) {
          return item.documentType.id == claim_type_str;
        });
        local = dataFil;
      }

      if (this.globalDocFilterStr) {
        let txt = new RegExp(this.globalDocFilterStr, "i");
        let dataFil = _.filter(local, function (item) {
          return item.fileName_1 && item.fileName_1.search(txt) >= 0 
            || item.fileName_2 && item.fileName_2.search(txt) >= 0
            || item.fileName_3 && item.fileName_3.search(txt) >= 0
            || item.fileName_4 && item.fileName_4.search(txt) >= 0
            || item.fileName_5 && item.fileName_5.search(txt) >= 0;
        });
        local = dataFil;
      }

      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }
      pagination = this.$refs.vuetable.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },
    clearGlobalDocSearchString() {
      this.globalDocFilterStr = "";
      this.$refs.vuetable.refresh();
    },
    startGlobalDocSearchString() {
      this.$refs.vuetable.refresh();
    },
    refreshSummaryDocumentList() {
      this.isLoading = true;
      this.documetList = [];
      if (this.claim_id) {
        const userdata = {
          claim_id: this.claim_id,
        };
        this.getAllClaimDocuments(userdata).then((data) => {
          if (data.data.errors) {
          } else {
            if (data.data) {
              this.documetList = data.data;
            }
          }
          this.isLoading = false;
        });
      } else {
        this.documetList = [];
        this.isLoading = false;
      }
    },
    refreshClaimDocuments() {
      if (this.claim_id) {
        this.claimDocumetList = [];
        this.isLoading = true;
        const param = {
          claim_id: this.claim_id,
        };
        this.getAllClaimDocumentsWithArchive(param).then((data) => {
          if (data.data.success.status) {
            this.claimDocumetList = data.data.success.data;

            this.claimDocumetList = data.data.success.data.map(x => {
              return {
                ...x,
                fileName: this.multiFileUploadString(x), 
              };
            });

            this.docTypeOptions = [
              {
                id: "",
                label: "All",
              },
            ];
            let filtered = this.claimDocumetList.filter((docData) => {
              if(this.docTypeOptions.find(d => d.id == docData.documentType.id) == null){
                let obj = {
                  id: docData.documentType.id,
                  label: docData.documentType.type,
                };
                this.docTypeOptions.push(obj);
              }
            });
          } else {
          }
          this.isLoading = false;
        });
      }
    },
    getPendingDocTypes() {
      if (this.claim_id) {
        this.isLoading = true;
        const param = {
          claim_id: this.claim_id,
        };
        this.getAllPendingDocTypes(param).then((data) => {
          if (data.data.success.status) {
            this.pendingUploadDocuments = data.data.success.data;
          } else {
          }
          this.isLoading = false;
        });
      }
    },
    tagDocumentModel(pa0rams) {
      this.getPendingDocTypes();
      this.source_doc_id = params.id;
    },
    tagClaimDocuments() {
      this.isLoading = true;
      let formData = new FormData();
      formData.append("sourceDocId", this.source_doc_id);
      formData.append("destinationDocId", this.tagging_document);
      this.tagClaimDocumentTypes(formData).then((data) => {
        if (data.data.success && data.data.success.status) {
          this.$snotify
            .success(data.data.success.data, "Success!", {
              position: "centerTop",
            })
            .on("destroyed", () => { });
          this.$bvModal.hide("modal-tag");
          this.refreshClaimDocuments();
          this.refreshSummaryDocumentList();
        } else {
        }
        this.isLoading = false;
      });
    },

    load: function () {
      let rowHeight = this.$refs.grid.ej2Instances.getRowHeight();  //height of the each row
      let gridHeight = this.$refs.grid.height;  //grid height
      let pageSize = this.$refs.grid.pageSettings.pageSize;   //initial page size
      let pageResize = (gridHeight - (pageSize * rowHeight)) / rowHeight; //new page size is obtained here
      this.$refs.grid.pageSettings = { pageSize: pageSize + Math.round(pageResize) };
    },

    passwordClick(args) {
      alert(JSON.stringify(args));
      this.$refs.modalDialog.show();
    },
    onRowSelected(args) {
      //alert("Current row details - " + JSON.stringify(args));
    },

    modalBtnClick: function () {
      this.$refs.modalDialog.show();
    },
    modalDlgClose: function () {
      document.getElementById('modalbtn').style.display = '';
    },
    modalDlgOpen: function () {
      document.getElementById('modalbtn').style.display = 'none';
    },
    overlayClick: function () {
      this.$refs.modalDialog.hide();
    },
    async onFileUploaded($event) { 
        var self = this;
        this.selectedFileForUpload = $event.target.files[0];

          let params = {
            documentTypeId: self.documentType,
            clientId: self.client_id,
            claimId: self.claim_id,
            uploadFile: self.selectedFileForUpload
        };

        await this.documentRead(params);

        this.refreshClaimDocuments();
        this.refreshSummaryDocumentList();

        this.documentType = null;
        this.$refs.fileUploader.value = null;
    },
    isDocumentUploadDisabled() {
      return this.documentType == null;
    },
  },
};
</script>

<style>
.custom-success-alert {
  background-color: green !important;
  color: #ffffff !important;
}

.custom-danger-alert {
  color: #ffffff !important;
  background-color: #8b2326 !important;
}
</style>
